'use client'
import { cn } from 'app/lib/utils'
import { ReactNode, useState } from 'react'
import ScrollDetector from 'components/ScrollDetector'
import Logo from 'components/layout/Images/Logo'
import { parseTheme } from 'app/lib/parseConfigTheme'

interface LandingNavbarProps {
    children: ReactNode
    config: IDomainConfig
    isPreview?: boolean
}

const LandingNavbar = ({ children, config, isPreview = false }: LandingNavbarProps) => {
    const [isScrolled, setIsScrolled] = useState(false)

    // Get layout size from theme
    const theme = config?.theme ? parseTheme(config.theme) : null
    const layoutSize = theme?.branding?.layout_size || 'compact'
    const isWide = layoutSize === 'wide'

    // Padding and height classes based on layout size
    const paddingClasses = isWide ? 'px-3 md:px-6 lg:px-[5vw]' : 'px-3 md:px-4 lg:px-[3vw]'
    const heightClass = isWide ? 'h-16' : 'h-14'

    return (
        <div
            className={cn(
                'left-0 right-0 w-full transition-all duration-300',
                isPreview
                    ? 'sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-md supports-[backdrop-filter]:bg-background/60 shadow-sm'
                    : 'fixed top-0 z-[999]',
                !isPreview && isScrolled && 'backdrop-blur-md border-b border-gray-700'
            )}
        >
            {!isPreview && <ScrollDetector onScroll={setIsScrolled} />}
            <div className={cn('flex items-center justify-between w-full', paddingClasses, heightClass)}>
                <Logo config={config} />
                <div
                    className={cn('flex items-center gap-4', isWide ? 'text-base md:text-lg' : 'text-sm md:text-base')}
                >
                    {children}
                </div>
            </div>
        </div>
    )
}

export default LandingNavbar
